import { cn } from "@/lib/utils";

interface TextCellProps {
  value: string | number | null | undefined;
  fallback?: string;
  className?: string;
  muted?: boolean;
  mono?: boolean;
  truncate?: boolean;
  maxWidth?: number;
}

export function TextCell({
  value,
  fallback = "—",
  className,
  muted,
  mono,
  truncate,
  maxWidth,
}: TextCellProps) {
  const display = value != null && value !== "" ? String(value) : fallback;

  return (
    <span
      className={cn(
        "text-sm",
        muted && "text-(--color-text-secondary)",
        mono && "font-mono",
        truncate && "block truncate",
        className,
      )}
      style={truncate && maxWidth ? { maxWidth } : undefined}
    >
      {display}
    </span>
  );
}
